import { LogBoxItem } from "models";

export enum LogBoxActions {
  AddToLogBox = "logbox/add_to_log",
  CloseNotification = "logbox/close_notification",
}

export interface AddToLogAction {
  type: LogBoxActions.AddToLogBox;
  payload: LogBoxItem;
}

export interface CloseNotificationAction {
  type: LogBoxActions.CloseNotification;
}

export const addToLog = (logItem: LogBoxItem): AddToLogAction => {
  return {
    type: LogBoxActions.AddToLogBox,
    payload: logItem,
  };
};

export const closeNotification = () => {
  return {
    type: LogBoxActions.CloseNotification,
  };
};

export type LogBoxActionTypes = AddToLogAction | CloseNotificationAction;
